import { useState, useEffect } from "react";

const SEARCH_LOADING_MESSAGES = [
  "Hold on",
  "Give us a sec",
  "We're on it",
  "Digging in",
  "Searching",
  "Hang tight",
  "Looking everywhere",
  "One moment",
  "Searching now",
  "Give us a minute",
  "Almost there",
  "Finding it",
  "Working on it",
  "Diving in",
  "Mapping it out",
  "Tracking it down",
  "Scanning through",
];

/**
 * Returns a cycling loading message for search UIs.
 * Starts at a random message and rotates every 2.5s while `isLoading` is true.
 */
export function useSearchLoadingMessage(isLoading: boolean): string {
  const [index, setIndex] = useState(() =>
    Math.floor(Math.random() * SEARCH_LOADING_MESSAGES.length),
  );

  useEffect(() => {
    if (!isLoading) return;
    const id = setInterval(() => {
      setIndex(prev => (prev + 1) % SEARCH_LOADING_MESSAGES.length);
    }, 2500);
    return () => clearInterval(id);
  }, [isLoading]);

  return SEARCH_LOADING_MESSAGES[index];
}
